import React, { useEffect, useRef, useState } from 'react';
import GlobalUpsellingCarouselStyles from './GlobalUpsellingCarouselStyles';
import { ONLINE_PHARMACY_ROUTE } from '@common/Utility/constants';
import CommonProductCarousel from '../CommonProductCarousel/CommonProductCarousel';
import BannerSliderWithImage from '../BannerSliderWithImage/BannerSliderWithImage';
import Link from 'next/link';
import * as apiActions1 from 'aster-foundation/core/epharmacy/Pharmacy/redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { getReferralPageForGA, convertStringtoTitleCase, errorHandling } from '@common/Utility/common-utils';
import { dataLayerSendEvent } from 'Epharmacy/EpharmacyAnalytics';
import { MY_ASTER_CATEGORY } from '@common/Constants/analytics';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';

const GlobalUpsellingCarousel = (props) => {
  const router = useRouter();
  const generateURL = useNavigationURL();
  const referralPageForGa = getReferralPageForGA(router.asPath);
  const dispatch = useDispatch();
  const zonedata = useSelector((state) => state?.app?.userLocationReducer?.zone);
  const [carouselData, setcarouselData] = useState(null);
  const [isBannerEmpty, setIsBannerEmpty] = useState(false);

  const dataObj = {
    data: {
      data: carouselData?.body?.data?.products,
    },
  };

  useEffect(() => {
    const zoneData = zonedata ? zonedata.join(',') : localStorage.getItem('userZone');
    const keyid = props?.keyid;
    const params = {
      key: keyid,
      zone: zoneData,
    };
    if (zoneData.length) {
      dispatch(
        apiActions1.getCrossModuleComponentData({
          params,
          onSuccess: (response) => {
            setcarouselData(response);
          },
          onFailure: (err) => {
            errorHandling(err, true, props?.screenType, props?.pageType);
          },
        }),
      );
    }
  }, [zonedata.length]);

  const redirectUrl = carouselData?.body?.data?.redirectionUrl;
  const pageBanners = carouselData?.body?.data?.banners?.map((bannerItem, index) => {
    return {
      imageWeb: bannerItem?.webImage,
      linkWeb: bannerItem?.ctaWebLink,
      imageMobile: bannerItem?.appImage,
      position: bannerItem?.priority,
      bannerName: bannerItem?.bannerName,
    };
  });
  useEffect(() => {
    if (!pageBanners || pageBanners.length === 0) {
      setIsBannerEmpty(true);
    }
  }, [pageBanners]);
  let carousel_title = carouselData?.body?.data?.title;
  let istitle = carousel_title !== null && carousel_title !== undefined && carousel_title.length > 0;

  const clickViewAllLink = () => {
    if (props?.screenType === 'booking confirmation' || props?.screenType === 'appointment detail') {
      const serializedAppointment = JSON.parse(sessionStorage.getItem('serializedAppointment'));
      
      dataLayerSendEvent('view_all_link_click', {
        screen_name: props?.screenType,
        section_name: carousel_title,
        page_type: props?.pageType,
        referrer_page: props?.referrerPage,
        myaster_category: MY_ASTER_CATEGORY.AE,
        ...(serializedAppointment?.doctorSpecialty? { speciality: serializedAppointment?.doctorSpecialty?.toLowerCase() } : {}),
        ...(serializedAppointment?.consultationType  ? { appointment_mode : serializedAppointment?.consultationType?.toLowerCase() } : {}),
        ...(serializedAppointment?.doctorName ? { doctor_name: serializedAppointment?.doctorName?.toLowerCase() } : {}),
        ...(serializedAppointment?.facilityName ? { facility_name: serializedAppointment?.facilityName?.toLowerCase() } : {}),
      });
    }
  };

  return (
    <GlobalUpsellingCarouselStyles
      isTitle={istitle}
      isViewAll={carouselData?.body?.data?.isViewAll}
      isBannerEmpty={isBannerEmpty}
    >
      {carouselData && carouselData?.body?.data?.products?.length > 0 &&
        (carouselData?.body?.data?.banners?.length > 0 ||
          carouselData?.body?.data?.products?.length > 0 ||
          carouselData?.body?.data?.isViewAll ||
          carouselData?.body?.data?.title) && (
          <div className="container_dynamic">
            {carouselData?.body?.data?.title && carouselData?.body?.data?.isViewAll && (
              <>
                <div className="titleContainer">
                  <div className="text">{convertStringtoTitleCase(carouselData?.body?.data?.title)}</div>
                  {carouselData?.body?.data?.isViewAll && (
                    <div className="view">
                      <Link href={generateURL(redirectUrl)} passHref>
                        <a onClick={clickViewAllLink}>View All</a>
                      </Link>
                    </div>
                  )}
                </div>
                <div className="commonwrapper">
                  <CommonProductCarousel
                    data={{ productList: dataObj?.data }}
                    isGlobalCarousel={props?.screenType === 'booking confirmation' || props?.screenType === 'appointment detail' ? false : true}
                    isTitle={istitle}
                    isViewAll={carouselData?.body?.data?.isViewAll}
                    screenType={props?.screenType}
                    responsiveProduct={props?.responsiveProduct}
                    sectionTitle={(props?.screenType === 'booking confirmation' || props?.screenType === 'appointment detail') && carousel_title}
                    referrerPage = {props?.screenType === 'booking confirmation' || props?.screenType === 'appointment detail' ? props?.referrerPage : ''}
                    pageType = {props?.screenType === 'booking confirmation' || props?.screenType === 'appointment detail' ? props?.pageType : ''}
                  />
                  {props?.screenType !== 'booking confirmation' && props?.screenType !== 'appointment detail' && (
                    <BannerSliderWithImage
                      isGlobalCarousel={true}
                      data={pageBanners}
                      sectionName={'dynamic'}
                      appVariant={'plp-banner'}
                      screenName={referralPageForGa}
                      isTitle={istitle}
                      isViewAll={carouselData?.body?.data?.isViewAll}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        )}
    </GlobalUpsellingCarouselStyles>
  );
};
CommonProductCarousel.propTypes = {
  keyid: PropTypes.string,
  isBannerEmpty: PropTypes.bool,
  screenType: PropTypes.string,
  responsiveProduct: PropTypes.array,
};
export default GlobalUpsellingCarousel;
